var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-telegram-bot"},[(_vm.isMobile)?_c('btn-back',{attrs:{"label":_vm.$t('msg.toOther'),"to":{name: 'other'}}}):_vm._e(),_c('card',{staticClass:"card_max-xs",attrs:{"show-header":false}},[_c('telegram-setting')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }